import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { ALL_TZ, tzAbbr } from "@/lib/time";

export const TimezoneSelect = ({ value, onChange, testId = "timezone-select" }) => {
  const [open, setOpen] = useState(false);
  const now = new Date().toISOString();
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className="flex w-full items-center justify-between border border-black/20 bg-white px-3 py-2.5 text-left text-sm outline-none focus:border-[#0A0A0A]">
          <span className="min-w-0 break-words">{value.replace(/_/g, " ")} <span className="text-[#57534E]">· {tzAbbr(now, value)}</span></span>
          <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[min(92vw,360px)] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search city or region…" data-testid={`${testId}-search`} />
          <CommandList className="max-h-72">
            <CommandEmpty>No time zone found.</CommandEmpty>
            <CommandGroup>
              {ALL_TZ.map((tz) => (
                <CommandItem key={tz} value={tz.replace(/_/g, " ")} onSelect={() => { onChange(tz); setOpen(false); }} data-testid={`tz-option-${tz}`}>
                  <Check className={`mr-2 h-4 w-4 ${tz === value ? "opacity-100" : "opacity-0"}`} />
                  <span className="min-w-0 flex-1 break-words">{tz.replace(/_/g, " ")}</span>
                  <span className="ml-2 text-xs text-[#57534E]">{tzAbbr(now, tz)}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
